import React from 'react';
import {Button, ButtonGroup} from 'reactstrap';
import './PlayerControls.css';
import PropTypes from 'prop-types';

function getValue(vf) {
    return typeof vf === "function" ? vf() : vf;
}

class PlayerControls extends React.Component{

    constructor(props){
        super(props);
    }

    play(){
        this.btnPlay.click();
    }

    stop(){
        this.btnStop.click();
    }

    pause(){
        this.btnPause.click();
    }

    render(){

        const props = this.props;
        const canPlay = getValue(props.canPlay);
        const isPlaying = getValue(props.isPlaying);
        const isPaused = getValue(props.isPaused);

        return (<ButtonGroup style={props.style}>
            <Button ref={r => this.btnStop = r} color={props.color || "primary"} style={props.stopStyle} disabled={!canPlay || (!isPlaying && !isPaused)} className="player-btn" onClick={props.onStop}>{props.stopBtnContent}</Button>
            <Button ref={r => this.btnPause = r} color={props.color || "primary"} style={props.pauseStyle} disabled={!canPlay && !isPaused || !isPlaying} className="player-btn" onClick={props.onPause}>{props.pauseBtnContent}</Button>
            <Button ref={r => this.btnPlay = r} color={props.color || "primary"} style={props.playStyle} disabled={!canPlay || isPlaying} className="player-btn" onClick={props.onPlay}>{props.playBtnContent}</Button>
        </ButtonGroup>);

    }

}

PlayerControls.propTypes = {

    style: PropTypes.object,
    canPlay: PropTypes.any,
    isPaused: PropTypes.any,

    color: PropTypes.string,

    onPlay: PropTypes.func,
    onPause: PropTypes.func,
    onStop: PropTypes.func,

    playStyle: PropTypes.any,
    playBtnContent: PropTypes.any,

    stopStyle: PropTypes.any,
    stopBtnContent: PropTypes.any,

    pauseStyle: PropTypes.any,
    pauseBtnContent: PropTypes.any
};

PlayerControls.defaultProps = {
    playBtnContent: <span><i className="fa fa-play"></i> Play</span>,
    stopBtnContent: <span><i className="fa fa-stop"></i> Stop</span>,
    pauseBtnContent: <span><i className="fa fa-pause"></i> Pause</span>
};

export default  PlayerControls;


// WEBPACK FOOTER //
// ./src/components/PlayerControls/PlayerControls.js